import { render, staticRenderFns } from "./ManageClientAppAccess.vue?vue&type=template&id=702ebcc6&"
import script from "./ManageClientAppAccess.vue?vue&type=script&lang=js&"
export * from "./ManageClientAppAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports